import { useEffect, useState } from "react";
import QRCode from "qrcode";
import { QrCode, Copy, Download } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { getWalkinLink } from "@/lib/api";

// Settings → this gym's pre-sale questionnaire QR code, to print for the front desk.
export default function WalkinQrCard() {
  const [link, setLink] = useState(null);
  const [png, setPng] = useState("");
  useEffect(() => {
    getWalkinLink().then(async (l) => {
      setLink(l);
      setPng(await QRCode.toDataURL(l.url, { width: 640, margin: 2, errorCorrectionLevel: "M" }));
    }).catch(() => setLink(null));
  }, []);
  if (!link) return null;
  const copy = async () => {
    try { await navigator.clipboard.writeText(link.url); toast.success("Link copied"); }
    catch { toast.error("Couldn't copy. Select the link and copy it."); }
  };
  return (
    <section className="card-surface p-6 space-y-4" data-testid="walkin-qr">
      <div className="flex items-center gap-2"><QrCode className="h-4 w-4 text-zinc-400" /><h3 className="font-semibold">Pre-sale questionnaire QR code</h3></div>
      <p className="text-xs text-zinc-500 max-w-xl">
        Print this for the front desk at {link.gym}. Prospects scan it and fill in the pre-sale questionnaire on their phone;
        they then appear under "Waiting for a consult" on the New Consult page.
      </p>
      <div className="flex flex-wrap items-center gap-6">
        {png && <img src={png} alt={`QR code for ${link.url}`} className="h-48 w-48 rounded-lg bg-white p-2" />}
        <div className="space-y-3 min-w-0">
          <div className="font-mono text-sm text-zinc-200 break-all select-all">{link.url}</div>
          <div className="flex flex-wrap gap-2">
            <Button type="button" variant="outline" className="rounded-full border-[#262626]" onClick={copy}><Copy className="h-4 w-4 mr-1.5" />Copy link</Button>
            {png && (
              <a href={png} download={`liftr-presale-questionnaire-${link.slug}.png`}>
                <Button type="button" variant="outline" className="rounded-full border-[#262626]"><Download className="h-4 w-4 mr-1.5" />Download QR</Button>
              </a>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
